import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  DeliveryPeriod,
  UTCDeliveryPeriod,
} from '@epicuro-next/ataraxia/models';
import { isNowDateContainer } from '@epicuro-next/state/config-strip-state';
import {
  firstDayOfWeek,
  getWeekNumberAndYear,
  lastWorkDayOfWeek,
} from '@epicuro-next/utilities';
import { DeliveryWindowType } from 'graphql-api/baskets-api-interfaces';

@Component({
  selector: 'epc-delivery-period-date-label',
  templateUrl: './delivery-period-date-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeliveryPeriodDateLabelComponent {
  @Input() public intervalType: DeliveryWindowType = DeliveryWindowType.Day;

  @Input() public set deliveryData(deliveryData: string | UTCDeliveryPeriod) {
    if (this.isSimpleLabel(deliveryData)) {
      this.simpleLabel = deliveryData;
      this.complexLabel = null;
      if (this.intervalType === DeliveryWindowType.Week)
        this.setWeekRange(deliveryData);
    } else {
      this.complexLabel = deliveryData;
      this.simpleLabel = null;
    }
  }

  public weekRange: DeliveryPeriod;
  public deliveryWindowType = DeliveryWindowType;
  public isNowDateContainer = isNowDateContainer;

  public complexLabel: UTCDeliveryPeriod | null;
  public simpleLabel: string | null;

  public isSimpleLabel(
    deliveryData: string | UTCDeliveryPeriod,
  ): deliveryData is string {
    return typeof deliveryData === 'string';
  }

  private setWeekRange(deliveryData: string) {
    const lastDay = lastWorkDayOfWeek(new Date(deliveryData));
    const firstDay = firstDayOfWeek(new Date(deliveryData));

    this.weekRange = new DeliveryPeriod(firstDay, lastDay);
  }

  public getYearForWeekDate(date: Date) {
    return getWeekNumberAndYear(date).year;
  }
}
